import util from '../util'

let base = window.$servicePath


export default {
    /**
     * 获取文件列表
     * @param params  {appId:"应用id",folder:"文件夹名"}
     * @returns {*}
     */
    listFiles(params) {
        return util.ajax(`${base}/api/file/listFiles`, params);
    },
    /**
     * 删除文件
     * @param params {appId:"应用id",folder:"文件夹名",name:"文件名"}
     * @returns {*}
     */
    deleteFile(params) {
        return util.ajax(`${base}/api/file/deleteFile`, params);
    },
    downloadFile(params) {
        return util.downloadAttachment(`${base}/api/file/download`, params);
    },
    downloadFile2(params) {
        return util.downloadAttachment2({ url: `${base}/api/file/download`, params: params });
    },
    /**
     * 删除文件夹
     * @param  params {appId:"应用id",folder:"文件夹名"}
     * @returns {*}
     */
    deleteFolder(params) {
        return util.ajax(`${base}/api/file/deleteFolder`, params);
    },
    /**
     * 添加文件夹
     * @param params {appId:"应用id",folder:"文件夹名"}
     * @returns {*}
     */
    addFolder(params) {
        return util.ajax(`${base}/api/file/addFolder`, params);
    },
    listFolder(params) {
        return util.ajax(`${base}/api/file/listFolder`, params);
    }

}


// WEBPACK FOOTER //
// ./src/common/api/file-manager.js